<button mat-flat-button class="nova__button__secondary" [matMenuTriggerFor]="createButtonMenu">
    CREATE <em class="material-icons">arrow_drop_down</em>
    <mat-menu #createButtonMenu="matMenu">
        <button mat-menu-item (click)="createApplication()">Application Doc</button>
        @if (showNewSubmittal) {
        <button mat-menu-item (click)="onNewSubmittal()">PerDiem Submittal from Scratch</button>
        }
        <button mat-menu-item (click)="onTicket()">Ticket</button>
    </mat-menu>
</button>